import { ENDPOINTS } from 'configs/endpoints';
import { SubAgentEntityApi, subAgentListSchema } from 'entities/SubAgent';
import { logApiErrWithSentry } from 'scripts/initSentry';
import { apiStore } from 'stores/global/ApiStore';
import { createFullName } from 'utils/createFullName';

const loadSubAgentsRequest = apiStore.createRequest({
  url: ENDPOINTS.subAgent.list,
});

export const getSubAgentOptions = async (params: { limit: number; offset: number; search: string; keys: string[] }) => {
  const requestPayload = {
    limit: params.limit,
    offset: params.offset,
    search: params.search || undefined,
  };

  const response = await loadSubAgentsRequest.call<{ items: SubAgentEntityApi[]; total: number }>({
    params: requestPayload,
  });

  if (response.isError) {
    logApiErrWithSentry({
      endpoint: ENDPOINTS.subAgent.list,
      method: 'GET',
      requestPayload,
      response,
    });

    return { isError: true, data: { items: [], total: 0 } };
  }

  const parsed = subAgentListSchema.safeParse(response.data);

  return {
    isError: false,
    data: {
      items:
        parsed.data?.items?.map((item) => ({
          key: item.id.toString(),
          value: createFullName(item),
        })) || [],
      total: response.data.total,
    },
  };
};
